import { render, staticRenderFns } from "./BubbleSolid.vue?vue&type=template&id=4f5dbd6a&scoped=true&"
var script = {}
import style0 from "./BubbleSolid.vue?vue&type=style&index=0&id=4f5dbd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5dbd6a",
  null
  
)

export default component.exports